import React from "react";
import { Link } from "react-router-dom";
import { Flex, Tooltip } from "@fluentui/react-northstar";
import { UserFriendsIcon, MeetingTimeIcon, LocationIcon, ArchiveIcon } from "@fluentui/react-icons-northstar";
import IReport from "../interfaces/IReport";
import styles from "./reportItem.module.scss";
import { numberToString } from "../common/numberOperations";
import { useApp } from "../contexts/appContext";
import { projectTimeToString } from "../common/textOperations";
import { getTimeFromDate } from "../common/dateOperations";

const ReportItem: React.FunctionComponent<IReport> = ({
    id, state, subject, start, end, project, durationInMinutes, overtime, shadowing, overhead, kilometers
}) => {
    const { state: appState } = useApp();

    return (
        <Link to={`/report/detail/${id}`} className={styles.itemContainer} style={{ color: appState.color }}>
            <Flex gap="gap.small" fill>
                <div className={state === 1 ? "" : styles.warning}>&nbsp;</div>
                <Flex column className={styles.hours}>
                    {numberToString(durationInMinutes / 60)}
                    <div className={styles.subTitle}>{getTimeFromDate(start)}&nbsp;-&nbsp;{getTimeFromDate(end)}</div>
                </Flex>
                <Flex column>
                    <span className={styles.title}>{subject}</span>
                    <span className={styles.subTitle}>{project.subject}</span>
                    <span className={styles.subTitle}>{projectTimeToString(project.plannedHours, project.remainingHours)}</span>
                </Flex>
                <Flex.Item push>
                    <Flex gap="gap.medium" vAlign="center" className={styles.rightSide}>
                        {!!kilometers && kilometers > 0 &&
                            <Tooltip content="Autem" position-align="before-center" trigger={<LocationIcon />} />
                        }
                        {overtime &&
                            <Tooltip content="Přesčas" position-align="before-center" trigger={<MeetingTimeIcon />} />
                        }
                        {shadowing &&
                            <Tooltip content="Shadowing" position-align="before-center" trigger={<UserFriendsIcon />} />
                        }
                        {overhead &&
                            <Tooltip content="Režie" position-align="before-center" trigger={<ArchiveIcon />} />
                        }
                    </Flex>
                </Flex.Item>
            </Flex>
        </Link>
    );
};

export default ReportItem;
